/* eslint-disable @typescript-eslint/no-explicit-any */
import { captureException } from '@sentry/browser';
import { ScopeContext } from '@sentry/types';

import { ENV } from '../environment';

const captureErrorInSentry = (error: any, scopeContext?: Partial<ScopeContext>) => {
  ENV.isDev && console.log('Sentry capture', { error, scopeContext });
  const { tags, ...context } = scopeContext || {};
  captureException(error, {
    ...context,
    // Prevent different errors from being merged in Sentry
    fingerprint: ['{{default}}', String(error?.message)],
    tags: {
      ...tags,
      application: 'example-package', // FYI : replace this with your package name
      path: window.location.pathname,
    },
  });
};

export const logError = (error: any, action?: string) => {
  ENV.isDev && action && console.error(`Failed to ${action} - `, error);
  ENV.isDev && !action && console.error(error);
  captureErrorInSentry(error, {
    contexts: action ? { action: { name: action } } : {},
    // tags: { foo : bar }, // FYI : Uncomment if you want to add specific tags for your package
  });
};

export const handleError = async <T>(action: () => T) => {
  try {
    const result = await action();
    return result;
  } catch (error) {
    logError({ error, action: action.name });
  }
  return undefined;
};
